import { Injectable } from '@angular/core';
import { Table } from '@app/modules/table/classes/table.class';
import { AuthService } from '@app/services';
import { Paginator, SortDirection } from '@app/classes';
import { FunnelTemplate } from '@app/models/recruiting/funnel-template.model';
import { TemplateName } from '../applicant-message-templates-table/columns';
import { EmailAutomation, NumberOfColumns } from './columns';
import { MenuColumnItem } from '@app/modules/table/interfaces/menu-column-item.interface';

@Injectable()
export class FunnelTemplatesIndexTable extends Table {
    static edit: MenuColumnItem = {
        label: 'edit',
        event: 'edit',
    };
    static duplicate: MenuColumnItem = {
        label: 'duplicate',
        event: 'duplicate',
    };

    static delete: MenuColumnItem = {
        label: 'delete',
        event: 'delete',
    };

    sortDirection = SortDirection.ASC;
    showMenuColumnOptions = true;

    constructor(protected auth: AuthService) {
        super(auth);
        this.boot();
    }

    setColumns(): void {
        const columns = [new TemplateName(), new NumberOfColumns(), new EmailAutomation()];

        this.addColumns(...columns);
    }

    setDataSource(): void {
        this.paginator = new Paginator(FunnelTemplate.query());
    }

    getMenuColumnOptionsForRow(): MenuColumnItem[] {
        return [FunnelTemplatesIndexTable.edit, FunnelTemplatesIndexTable.duplicate, FunnelTemplatesIndexTable.delete];
    }
}
